import { render, staticRenderFns } from "./Compress.vue?vue&type=template&id=6f81ff7a&scoped=true&"
import script from "./Compress.vue?vue&type=script&lang=js&"
export * from "./Compress.vue?vue&type=script&lang=js&"
import style0 from "./Compress.vue?vue&type=style&index=0&id=6f81ff7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f81ff7a",
  null
  
)

export default component.exports